import Vue from "vue";
import { cloneDeep } from "lodash";
import {
  treeWalker,
  treePeriodicConverter,
  treeBuildGroups,
  treeBuildEvents,
} from "../../utils/treeUtils";
import { vuexStoreBuilder } from "vuex-store-builder";

export const mutations = {
  Added_VALUES_SWITCH(state, data) {
    state.valuesAddedToChart = data;
  },

  UPDATE_CHART_VALUES(state, data) {
    state.updatedChartValues = data;
  },

  SET_PERIODIC(state, data) {
    state.periodic = data;
  },

  LOAD_NAMES(state, names) {
    state.names = names;
  },

  LOAD_RECORDS(state, recs) {
    state.records = recs;
  },

  UPDATE_RECORD_LIST(state, rec) {
    //state.records.push(rec);
  },

  SET_TARGET_NODE(state, targetNode) {
    const node = {
      text: targetNode.name,
      id: targetNode.id,
      data: targetNode.data,
      parent: targetNode.parent,
    };
    state.targetNode = node;
  },

  CHART_CATEGORY_FILTER(state, categoryIdList) {
    state.categoryIdList = categoryIdList;
  },

  FORMAT_CHART_NODE(state, node) {
    if (!node) {
      return;
    }
    node.node.value = node.value;
    state.nodeMap = {
      obj: node.node,
      root_id: state.parentId,
    };
  },

  UPDATE_CHART_DATA(state, chartData) {
    let testfind = state.chartDataList.find("Race");
  },

  LOAD_TEMPLATES(state, templatesList) {
    state.templates = templatesList;
  },

  LOAD_CATEGORIES(state, categories) {
    state.categories = categories;
  },

  SET_SELECTED_TEMPLATES(state, selectedTemplates) {
    state.selectedTemplates = selectedTemplates;
  },
  SET_SELECTED_CATEGORIES(state, selectedCategories) {
    state.selectedCategories = selectedCategories;
  },

  SET_NEW_TEMPLATE_DATA(state, newTemplateData) {
    state.newTemplate = newTemplateData;
  },
  // Update a periodic node's value
  UPDATE_NODE_PERIODIC_VALUE(state, { id, editIndex, index, newValue }) {
    const head = state.selectedRecords[state.currentlySelectedRecordIndex];
    const node = treeWalker(head, id);
    node.value[editIndex].val[index] = newValue;
  },
  ////////record nav /////////
  ADD_RECORD(state, record) {
    const newRecord = treePeriodicConverter(
      record,
      new Date(state.currentRecordDateTimeStamp)
    );

    state.selectedRecords.push(newRecord);
    // the following is leftover froms tonys system for displaying liquor tree
    let encounter = {
      tabIndex: 0,
      tab: "",
      content: newRecord,
    };
    state.encounters.push(encounter);
  },
  SET_CURRENT_RECORD(state, Record) {
    // state.currentlySelectedRecord = Record;
    state.eventz = {};
    state.groups = {};
    // for (let prop in state.currentlySelectedRecord) {
    //   delete state.currentlySelectedRecord[prop];
    // }
    // for (let prop in Record) {
    //   state.currentlySelectedRecord[prop] = Record[prop];
    // }
    Vue.set(state, "currentlySelectedRecord", cloneDeep(Record));
    const groupList = treeBuildGroups({}, Record);
    const eventList = treeBuildEvents({}, Record);

    Vue.set(state.groups, Record._id, groupList);
    Vue.set(state.eventz, Record._id, eventList);
  },
  SET_CURRENT_RECORD_INDEX(state, record) {
    if (record === null) return (state.currentlySelectedRecordIndex = -1);
    state.currentlySelectedRecordIndex = state.selectedRecords.findIndex(
      (thisRecord) => {
        return record._id === thisRecord._id;
      }
    );
  },
  UPDATE_CURRENT_RECORD(state, { RecordIndex, Record }) {
    const groupList = treeBuildGroups({}, Record);
    const eventList = treeBuildEvents({}, Record);

    Vue.set(state.groups, Record._id, groupList);
    Vue.set(state.eventz, Record._id, eventList);
    Vue.set(state.selectedRecords, RecordIndex, Record);
  },
  RESET_ALL_RECORDS(state) {
    state.selectedRecords = [];
    state.currentlySelectedRecordIndex = 0;
    state.selectedRecords = [];
    state.groups = {};
    state.eventz = {};
    state.currentlySelectedAccount = null;
  },

  /////tabs/////
  ADD_TAB(state, tab) {
    state.tabs.push(tab);
  },
  SET_CURRENT_TAB(state, tab) {
    state.currentlySelectedTab = tab;
  },
  UPDATE_ACTIVE_TAB(state, activeTabValue) {
    state.activeTabIndex = activeTabValue;
  },
  REMOVE_TAB(state, tabtodeleteindex) {
    state.tabs.splice(tabtodeleteindex, 1);
  },
  RESET_TABS(state) {
    state.tabs = [];
    state.currentlySelectedTab = {};
    state.currentlySelectedTabType = "";
    state.activeTabIndex = 0;
  },
  UPDATE_ACTIVE_TAB_DATA(state, { tabItemToUpdate, recordToUpdate }) {
    const affectedTabs = state.tabs.filter(
      (tab) => tab.recordId === tabItemToUpdate.recordId
    );
    affectedTabs.forEach((tab) => {
      if (tab.name === tab.recordName) {
        tab.name = recordToUpdate.name;
      }
      tab.recordName = recordToUpdate.name;
    });
    state.currentlySelectedRecord.name = recordToUpdate.name;
  },
  UPDATE_TAB_TEXT(state, { recordItemId, newText }) {
    // Find all the tabs with this node/cateogry
    const openTabs = state.tabs.filter(
      (tab) => tab.recordItemId === recordItemId
    );
    openTabs.forEach((tab) => {
      // Update tab name if this record is open in a tab
      tab.name = newText;
    });
  },
  ////////record viewer //////

  SET_UNEDITED_RECORD(state, record) {
    state.uneditedCurrentRecord = cloneDeep(record);
  },
  RESET_UNEDITED_RECORD(state) {
    state.uneditedCurrentRecord = {};
  },
  REVERT_TO_UNEDITED_STATE(state, recordIndex) {
    Vue.set(state.selectedRecords, recordIndex, state.uneditedCurrentRecord);
    state.currentlySelectedRecord = state.uneditedCurrentRecord;
  },

  UPDATE_RECORD(state, RecordItem) {
    state.currentlySelectedRecordItem = RecordItem;
  },
  ADD_HIDDEN_RECORD_ITEM(state, RecordItemId) {
    state.conditionallyHiddenRecordItemIds.push(RecordItemId);
  },
  REMOVE_ALL_HIDDEN_RECORD_ITEMS(state) {
    state.conditionallyHiddenRecordItemIds = [];
  },
  REPLACE_SELECTED_RECORDS_ARRAY(state, records) {
    state.selectedRecords = cloneDeep(records);
  },

  // Group mutations
  ADD_NODE_TO_GROUP(state, { group, node, recordId }) {
    if (state.groups[recordId]) {
      const allGroups = state.groups[recordId];
      if (allGroups[group]) {
        allGroups[group].push(node);
      } else {
        Vue.set(state.groups[recordId], group, [node]);
      }
    } else {
      state.groups[recordId] = {};
      Vue.set(state.groups[recordId], group, [node]);
    }
  },
  REMOVE_NODE_FROM_GROUP(state, { group, node, recordId }) {
    const index = state.groups[recordId][group].findIndex(
      (group) => group._id === node._id
    );
    if (index !== -1) {
      state.groups[recordId][group].splice(index, 1);
      if (state.groups[recordId][group].length === 0) {
        // If there are no more nodes in this group, remove it
        Vue.delete(state.groups[recordId], group);
      }
    }
  },
  UPDATE_GROUP(state, { group, members, recordId }) {
    if (!state.groups[recordId]) {
      state.groups[recordId] = {};
    }
    Vue.set(state.groups[recordId], group, members);
  },
  REPLACE_GROUP_LIST(state, groupList) {
    state.groups = groupList.concat();
  },
  DELETE_GROUP(state, { group, recordId }) {
    Vue.delete(state.groups[recordId], group);
  },

  // Analysis group mutations
  ADD_NODE_TO_ANALYSIS_GROUP(state, { group, node, recordId }) {
    if (state.analysis[recordId]) {
      const allGroups = state.analysis[recordId];
      if (allGroups[group]) {
        allGroups[group].push(node);
      } else {
        Vue.set(state.analysis[recordId], group, [node]);
      }
    } else {
      state.analysis[recordId] = {};
      Vue.set(state.analysis[recordId], group, [node]);
    }
  },
  REMOVE_NODE_FROM_ANALYSIS_GROUP(state, { group, node, recordId }) {
    // This will probably be needed as node/category names aren't unique
    // const index = state.analysis[recordId][group].findIndex(
    //   (group) => group._id === node._id
    // );
    const index = state.analysis[recordId][group].findIndex(
      (group) => group === node
    );
    if (index !== -1) {
      state.analysis[recordId][group].splice(index, 1);
      if (state.analysis[recordId][group].length === 0) {
        // If there are no more nodes in this group, remove it
        Vue.delete(state.analysis[recordId], group);
      }
    }
  },
  UPDATE_ANALYSIS_GROUP(state, { group, members, recordId }) {
    if (!state.analysis[recordId]) {
      state.analysis[recordId] = {};
    }
    Vue.set(state.analysis[recordId], group, members);
  },

  // Event group mutations
  ADD_NODE_TO_EVENTS_GROUP(state, { event, node, recordId }) {
    if (state.eventz[recordId]) {
      const allEvents = state.eventz[recordId];
      if (allEvents[event]) {
        allEvents[event].push(node);
      } else {
        Vue.set(state.eventz[recordId], event, [node]);
      }
    } else {
      state.eventz[recordId] = {};
      Vue.set(state.eventz[recordId], event, [node]);
    }
  },
  REMOVE_NODE_FROM_EVENTS_GROUP(state, { event, node, recordId }) {
    // This will probably be needed as node/category names aren't unique
    // const index = state.eventz[recordId][event].findIndex(
    //   (event) => event._id === node._id
    // );
    const index = state.eventz[recordId][event].findIndex(
      (event) => event._id === node._id
    );
    if (index !== -1) {
      state.eventz[recordId][event].splice(index, 1);
      if (state.eventz[recordId][event].length === 0) {
        // If there are no more nodes in this event, remove it
        Vue.delete(state.eventz[recordId], event);
      }
    }
  },
  UPDATE_EVENTS_GROUP(state, { event, members, recordId }) {
    if (!state.eventz[recordId]) {
      state.eventz[recordId] = {};
    }
    Vue.set(state.eventz[recordId], event, members);
  },
  DELETE_EVENTS_GROUP(state, { event, recordId }) {
    Vue.delete(state.eventz[recordId], event);
  },
  REPLACE_EVENTS_GROUP_LIST(state, eventList) {
    state.eventz = eventList.concat();
  },
  SET_CURRENT_RECORD_TIMESTAMP(state, datetime) {
    state.currentRecordDateTimeStamp = datetime;
  },
  SET_SCORE_FOR_NODE(state, { node_id, score }) {
    Vue.set(state.scores, node_id, score);
  },
  // RESET_UNEDITED_RECORD(state, selectedRecordItem) {
  //   state.uneditedcurrentlySelectedRecordItem = JSON.stringify(
  //     selectedRecordItem
  //   );
  // },
  // DISCARD_RECORD_CHANGES(state, oldtabpackage) {
  //   state.tabs.splice(
  //     state.tabs.indexOf(oldtabpackage[0]),
  //     1,
  //     oldtabpackage[1]
  //   );
  // },
  // SET_EDIT_MODE(state, boolean) {
  //   state.editMode = boolean;
  // },
  // SET_SHOW_UNSAVED_INTERCEPT(state, arrayofboolrecorditem) {
  //   state.showUnsavedChangesIntercept = arrayofboolrecorditem[0];
  //   state.navigatingtotab = arrayofboolrecorditem[1];
  // },
  // OPEN_NEW_TAB(state, selectedRecordItem) {
  //   state.tabs.push(selectedRecordItem);
  // },
  // updateActiveTab(state, activeTabValue) {
  //   state.activeTab = activeTabValue;
  // },
  // UPDATE_TABS(state, updatedTabs) {
  //   state.tabs = updatedTabs;
  // },
  // CLOSE_TAB(state, tabRecordItem) {
  //   state.tabs.splice(state.tabs.indexOf(tabRecordItem), 1);
  // },
  // SET_UNSAVEDTAB(state, boolean) {
  //   state.unsavedTab = boolean;
  // },
  //charts
  // OPEN_NEW_CHART(state, chartRecordItem) {
  //   state.chartViewActive = true;
  //   state.tabs.push(chartRecordItem);
  //   state.currentlySelectedRecordItem = chartRecordItem;
  // },
  // OPEN_CHART(state) {
  //   state.chartViewActive = true;
  // },

  // CLOSE_CHART(state) {
  //   state.chartViewActive = false;
  // },
  ////////////////////////////
  ////////User(Record) Notifications/////
  SET_USER_NOTIFICATIONS(state, notifications) {
    state.UserRecordNotifications = notifications;
  },

  ///////////ACCOUNTS///
  SET_ACCOUNT(state, accountusername) {
    state.currentlySelectedAccount = accountusername;
  },
};
